// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"41":"62942f5b","490":"8c8d492c"}[chunkId] + ".chunk.css";
};